var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-mockup"},_vm._l((_vm.rowList),function(r){return _c('Flexy',{key:r,attrs:{"even":true}},[_c('div',{class:_vm.isList?'mock-row':'mock-box'}),(!_vm.isList)?_c('div',{staticClass:"mock-box"}):_vm._e()])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }